export class VAS {
  timeAttendance: boolean = true;
  customers!: boolean;
  inventory!: boolean;
  olo!: boolean;

  public load(data: any): VAS {

    Object.assign(this, data);

    return this;
  }
}
